import { RouteRecordRaw } from 'vue-router';
import { ClientRoutes } from './client-routes';

// Content Route is a fallback route and therefor must be added last to vue-router
import { ContentRoute } from './content-routes/content.route';

export const routes: RouteRecordRaw[] = [...ClientRoutes, ContentRoute];
